<template>
  <div class="container testimonials" id="testimonials">
    <div class="content-heading is-flex">
      <h3 class="is-size-3">Testimonials</h3>
      <router-link to="/admin/testimonials/new" class="button is-info">Add New</router-link>
    </div>

    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" @confirmDeletePost='confirmDelete()' @selectBulkActions='selectBulkActions()' v-if="showModal" :header="header"/>
    </transition>

    <router-view></router-view>

    <div class="box">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th @click="sortBy('title')">
              Fullname
            </th>
            <th>
              Testimonial
            </th>
            <th>
              State
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(testimonial, index) in testimonials" :key="index">
            <td>
              <p>
                <router-link :to="'/admin/testimonials/edit/' + testimonial['.key']">
                  {{testimonial.fullname}}
                </router-link>
              </p>
            </td>
            <td>
              <p>{{testimonial.text}}</p>
              <div class="actions">
                <router-link :to="'/admin/testimonials/edit/' + testimonial['.key']">
                  <span class="has-text-info">Edit</span>
                </router-link>
                <span @click="deleteTestimonial(testimonial)" class="has-text-danger">Delete</span>
              </div>
            </td>
            <td>{{testimonial.state}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { testimonialsRef } from '@/firebase_config'
import modal from '@/components/shared/Modal'
import notifier from '@/mixins/notifier'

export default {
  name: 'testimonial',
  data () {
    return {
      showModal: false,
      header: '',
      kind: '',
      testimonial: null,
      sortKey: 'title'
    }
  },
  firebase: {
    testimonials: testimonialsRef
  },
  mixins: [notifier],
  computed: {},
  methods: {
    deleteTestimonial (testimonial) {
      this.header = 'Are you sure you want to delete this testimonial?'
      this.kind = 'deletePost'
      this.showModal = true
      this.testimonial = testimonial
    },
    confirmDelete () {
      this.$firebaseRefs.testimonials.child(this.testimonial['.key']).remove().then(() => {
        this.showNotification('success', 'Testimonial deleted successfully')
        this.showModal = false
        this.testimonial = ''
      })
    }
  },
  components: {
    modal
    // dropdown,
    // checkbox
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/Testimonials.vue